import { PartialCustomTheme } from './Theme';

export const monkeybookStandardTheme = {
  palette: {
    primary: '#47b406',
    text: {
      primary: 'black',
      button: {
        contained: 'white',
        outlined: 'white',
      },
    },
    background: 'white',
    toggleButton: {
      selectedBg: '#47b406',
    },
    border: '#47b406',
    warning: '#ed6c02',
  },
} satisfies PartialCustomTheme;
